module.exports = require('../../../redirects-list.json')
